import { PageProps } from './Page.interfaces';
import { Page } from './Page';
import { PublicHeader } from '../Header/PublicHeader/PublicHeader';
import { PublicFooter } from '../Footer/PublicFooter/PublicFooter';

export const PublicPage = (pageProps: PageProps) => {
  return <Page header={<PublicHeader />} footer={<PublicFooter />} {...pageProps} />;
};
